module.exports = __webpack_public_path__ + "media/metronic/_theme/media/misc/owl.video.play-4a37f8008959c75f619bf0a3a4e2d7a2.png";